import React from "react";
import { SvgIcon } from "@material-ui/core";


export default function SelectedProfileIcon(): JSX.Element {
    return (
        <SvgIcon viewBox="0 0 75 80" color="secondary">
            <path
                d="M73.5 39.703C73.5 60.8837 57.3027 77.906 37.5 77.906C17.6973 77.906 1.5 60.8837
                1.5 39.703C1.5 18.5222 17.6973 1.5 37.5 1.5C57.3027 1.5 73.5 18.5222 73.5 39.703Z"
                stroke="#333333"
                strokeWidth="3"
            />
            <path
                d="M36.3861 73.117C25.054 70.8785 19.7614 68.6671 14.1089 61.3241C15.8511 58.5777
                18.0706 57.6791 23.7623 57C27.3727 56.94 28.5775 56.0688 30.0742 53.8552C30.3942 52.2261
                30.5686 51.3085 30.0742 48.7449L28.2178 42.8484C24.5841 33.41 23.785 29.8291 27.1039
                20.8344C29.5525 17.7916 32.9279 15.4532 37.1287 15.7235C41.5718 15.079 44.8908 17.5271
                47.1534 20.8342C50.6536 30.3165 48.2445 34.9233 46.4108 42.8484C46.4108 42.8484 44.1009 46.8799
                43.8118 48.7449C43.5228 50.6099 43.5051 51.7044 43.8118 53.8552C45.2737 55.5269 46.3698 56.178
                48.6386 57C54.4439 57.0867 56.5674 58.5184 60.1485 61.3241C52.9735 69.5051 47.8543 72.2032
                36.3861 73.117Z"
                fill="#333333"
            />
        </SvgIcon>
    );
}
